export const lh = (sizePx: number, lineHeightPx: number) =>
  lineHeightPx / sizePx;
